import { PAYMENT_METHOD_HASH_TYPE_AFFIRM } from '../../constants';

export const affirmPaymentMethodHashPayloadFactory = (
  paymentMethodId: string,
): object => ({
  type: PAYMENT_METHOD_HASH_TYPE_AFFIRM,
  affirm: {
    token: paymentMethodId,
  },
});
